var map = {
	"./App.css": [
		519
	],
	"./Model/components/Components.module.css": [
		24
	],
	"./Model/components/UI/Label/Label.module.css": [
		814,
		7
	],
	"./Model/components/UI/Subtitle/Subtitle.module.css": [
		394
	],
	"./Model/components/UI/Title/Title.module.css": [
		392
	],
	"./academy.css": [
		822,
		3
	],
	"./components/Charts/Chart.module.css": [
		191
	],
	"./evorich.css": [
		823,
		4
	],
	"./lib/css/sidebar.css": [
		556
	],
	"./wodcom.css": [
		829,
		5
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1150;
module.exports = webpackAsyncContext;